<route>
{
    "name": "auth-oidc-start",
    "path": "/auth/oidc/start",
    "meta": {
        "title": "Autentificare",
        "permission": "guest",
        "fail": "/404"
    }
}
</route>

<template>
  <modal-layout class="white">
    <v-card :flat="true">
      <v-card-text class="text-xs-center py-5">
        <v-progress-circular
          v-if="!error"
          indeterminate
          color="primary"
        />
        <v-alert
          v-else
          :value="true"
          type="error"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
    </v-card>
  </modal-layout>
</template>

<script>
import ModalLayout from "Layouts/ModalLayout.vue";
import oidc from "Services/oidc";

export default {
  components: {
    ModalLayout
  },
  data: () => ({
    error: null
  }),
  async mounted() {
    try {
      if (!oidc.isEnabled()) {
        throw new Error("OpenID Connect is not configured. Check OIDC_CLIENT_ID.");
      }

      await oidc.signinRedirect();
    } catch (error) {
      console.error("OIDC redirect failed", {
        error,
        config: window.App?.oidc,
        location: window.location.origin
      });

      this.error = error.message || "OpenID Connect redirect failed.";
    }
  },
};
</script>
